var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value:
            _vm.modalVisibility &&
            !_vm.supportedLocales.includes(_vm.userLocale),
          expression:
            "modalVisibility && !supportedLocales.includes(userLocale)",
        },
      ],
      attrs: { id: "locale-modal-container" },
    },
    [
      _c("div", { staticClass: "locale-modal" }, [
        _c("button", {
          staticClass: "close",
          on: { click: _vm.toggleLocaleWarning },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "modal-content" }, [
          _c("p", [_vm._v(_vm._s(_vm.modalContent))]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.countries, function (country, i) {
              return _c("li", { key: i }, [
                _c(
                  "button",
                  {
                    class: country[0].toLowerCase(),
                    on: {
                      click: function ($event) {
                        return _vm.forceLocaleRedirect(country[0])
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(country[1]) +
                        "\n                    "
                    ),
                  ]
                ),
              ])
            }),
            0
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }